import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { useMPEFetch } from '@retail/app/hooks';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';
import { mpeApi } from '@retail/mgpris/config';
import { UnitDTO } from '@retail/products/types';

export function useFetchGlobalItemUnits(queryOptions: QueryOptions = {}) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<UnitDTO[]>({
    method: 'GET',
    queryKey: ['global-item-units'],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.globalItemUnits.getFullLinkPath(),
    }),
    ...queryOptions,
  });
}
